import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {SnapshotTypeBO} from "./SnapshotTypeBO";
import { WB_Snapshot_TypeRow} from "../PA.Core/PAdbSchemaRows";
import { esWB_Snapshot_Type} from "../PA.Core/PAdbSchema";
import {PAdbContext} from "../PA.Core/PAdbContext";

export class SnapshotTypeBOValidations{

    static async ValidateEmptyFields(aBO: SnapshotTypeBO): Promise<void> {

        let dbContext = new PAdbContext({})


            if (!aBO.WB_SnapshotType.isActive)
                return

            if (_.isEmpty(aBO.WB_SnapshotType.cif.SNAPSHOT_TYPE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "Snapshot Type ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_SnapshotType.cif.SNAPSHOT_TYPE_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyname',
                        type: MessageType.Error,
                        title: "Snapshot Type Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyname')
            }

            if (!_.isNumber(aBO.WB_SnapshotType.cif.WB_COMPANY_ID) || aBO.drWB_SnapshotType.cif.WB_COMPANY_ID==0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyCompany',
                        type: MessageType.Error,
                        title: "Enterprise Structure Company cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyCompany')
            }


            if (_.isEmpty(aBO.WB_SnapshotType.cif.SERVER_PROCESS_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyServerProcessId',
                        type: MessageType.Error,
                        title: "Server Process ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyServerProcessId')
            }

            // SnapshotTypes are considered duplicates only within the same Master Data Set
            let snapshotTypeRows: WB_Snapshot_TypeRow[] = await dbContext.findAll(esWB_Snapshot_Type,
                {where: {DELETED_IND: {neq: '1'},
                        WB_SNAPSHOTM_ID: {neq: aBO.WB_SnapshotType.cif.WB_SNAPSHOTM_ID},
                        WB_MDSET_ID: aBO.WB_SnapshotType.cif.WB_MDSET_ID,
                        SNAPSHOT_TYPE_ID: aBO.WB_SnapshotType.cif.SNAPSHOT_TYPE_ID}})



            if (!_.isEmpty(snapshotTypeRows)) {
                aBO.ValidateMessageProvider.addMessage({
                    code: "duplicateID", type: MessageType.Error,
                    title: 'Existing Snapshot Type with the same ID: ' +
                        '\nSnapshot Type: ' + _.map(snapshotTypeRows, (a) => `${a.cif.SNAPSHOT_TYPE_ID} (${a.cif.SNAPSHOT_TYPE_ID})`).join(","),
                    description: "",
                    subtitle: "",
                    count: 0
                })
            } else {
                aBO.ValidateMessageProvider.removeMessage("duplicateID")
            }


    }
}
